var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftdiscountIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.727,
    height: 7.789,
    viewBox: "1134.499 778.591 4.727 7.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1134.625 782.183 3.466-3.466a.428.428 0 0 1 .606 0l.404.404a.428.428 0 0 1 0 .605l-2.747 2.76 2.748 2.76a.428.428 0 0 1-.001.605l-.404.404a.428.428 0 0 1-.606 0l-3.466-3.466a.428.428 0 0 1 0-.606Z",
    fillRule: "evenodd",
    "data-name": "Icon awesome-chevron-left"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftdiscountIcon);
export default __webpack_public_path__ + "static/media/leftdiscountIcon.36216f25389f23e86f769497c735fbf8.svg";
export { ForwardRef as ReactComponent };